import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/config.service';
import { RequestResult, SectorOverviewItem, SectorPolygon } from '../../models';
import { Address } from '../../models/sector/address';
import { Street } from '../../models/sector/street';
import { BaseRestApiService } from '../base/base-rest.api.service';
import { LogService } from '../logging/log.service';

@Injectable()
export class SectorApiService extends BaseRestApiService {

    constructor(http: HttpClient, logService: LogService, private configService: ConfigService) {
        super(http, logService);
    }

    public getSectorById(sectorId: string): Observable<SectorPolygon> {
        const API_URL: string = this.configService.getEnv('sectorApi');
        return this.get(`${API_URL}/${sectorId}`)
            .map((response: RequestResult<any>) => new SectorPolygon(response.data))
            .catch((error: Response | any) => {
                return Observable.throw(error);
            });
    }

    public getSectorsByIds(sectorIds: string[]): Observable<SectorPolygon[]> {
        const API_URL: string = this.configService.getEnv('sectorApi');
        return this.post(`${API_URL}/bulk`, sectorIds)
            .map((response: RequestResult<any>) =>
                response.data.map((sectorPolygon: any) => new SectorPolygon(sectorPolygon))
            ).catch((error: Response | any) => {
                return Observable.throw(error);
            });
    }

    public getAddressesBySectorId(sectorId: string): Observable<Address[]> {
        const API_URL: string = this.configService.getEnv('sectorApi');
        return this.get(`${API_URL}/address/${sectorId}`)
            .map((response: RequestResult<any>) => response.data.map((address: Address) => new Address(address)))
            .catch((error: Response | any) => Observable.throw(error));
    }
    public getStreetsBySectoriD(sectorId: string): Observable<Street[]> {
        const API_URL: string = this.configService.getEnv('sectorApi');
        return this.get(`${API_URL}/street/${sectorId}`)
            .map((response: RequestResult<any>) => response.data.map((street: Street) => new Street(street)))
            .catch((error: Response | any) => Observable.throw(error));
    }

    public getSectorOverviewByIds(sectorIds: string[]): Observable<SectorOverviewItem[]> {
        const API_URL: string = this.configService.getEnv('sectorApi');
        return this.post(`${API_URL}/overview`, sectorIds)
            .map((response: RequestResult<any>) =>
                response.data.map((sectorOverviewItem: SectorOverviewItem) => new SectorOverviewItem(sectorOverviewItem)))
            .catch((error: Response | any) => Observable.throw(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/sector/sector.api.service.ts